<section class="loa-tracking" data-testid="loa-tracking-section">
  <div class="loa-tracking__header">
    <h2 class="loa-tracking__title">Letter of Adherence Tracking</h2>
    <p class="loa-tracking__subtitle">
      Track and manage Letter of Adherence documents for this Legal Entity
    </p>
  </div>

  <div class="loa-tracking__content">
    <div class="loa-tracking__field">
      <span class="loa-tracking__label">Letter of Adherence:</span>
      @if (loaDocuments && loaDocuments.length > 0) {
        <div class="loa-tracking__documents-list">
          @for (doc of loaDocuments; track doc) {
            <div class="loa-tracking__document-row" data-testid="loa-document-row">
              <a
                class="loa-tracking__document-link"
                data-testid="loa-document-link"
                (click)="downloadDocument(doc)"
                role="button"
                tabindex="0"
                (keydown.enter)="downloadDocument(doc)"
                (keydown.space)="downloadDocument(doc)"
              >
                <span class="loa-tracking__document-text">{{ doc.name }}</span>
                <span class="material-symbols-outlined loa-tracking__document-icon">draft</span>
              </a>
              @if (canDeleteDocument(doc)) {
                <button
                  class="loa-tracking__delete-btn"
                  data-testid="loa-delete-btn"
                  (click)="requestDeleteDocument(doc)"
                  aria-label="Remove document"
                >
                  <span class="material-symbols-outlined loa-tracking__delete-icon">close</span>
                </button>
              }
            </div>
          }
        </div>
      }
      @if (!loaDocuments || loaDocuments.length === 0) {
        <div class="loa-tracking__empty-state" data-testid="loa-empty-state">
          No documents uploaded
        </div>
      }
    </div>

    <div class="loa-tracking__field">
      <span class="loa-tracking__label">Date LOA Signed:</span>
      <div class="loa-tracking__date-text" data-testid="loa-date-signed">
        {{ documentDate || '--' }}
      </div>
    </div>
  </div>
</section>

<app-status-change-modal
  #deleteModal
  [isOpen]="isDeleteModalOpen"
  [title]="'Delete Document'"
  [initialState]="'custom-confirm'"
  (customNo)="onDeleteCancelled()"
  (customYes)="onDeleteConfirmed()"
  (closed)="onDeleteModalClosed()"
></app-status-change-modal>
